module.exports = __webpack_public_path__ + "static/img/logo1.bcdeca2d.png";